import { getConfig } from '../../utils/getConfig.js';

export const makeStreetViewStaticURL = (lat?: number, lng?: number) =>
  `https://maps.googleapis.com/maps/api/streetview?size=400x400&location=${lat},${lng}&key=${getConfig(
    'GOOGLE_MAPS_API_KEY',
  )}`;
